import { SharedConstants } from "../../../shared/constants/shared.constants";
export const NAME_TEXT = "Name";
export const EMAIL_TEXT = "Email";
export const SUBJECT_TEXT = "Subject";
export const MESSAGE_TEXT = "Message";
export const NAME_FORM_CONTROL = "name";
export const EMAIL_FORM_CONTROL = "email";
export const SUBJECT_FORM_CONTROL = "subject";
export const MESSAGE_FORM_CONTROL = "message";
export const SCREENSHOT_FORM_CONTROL = "screenShot";
export const OBJECT_NAME = "Afla feedback";
export const FILE_TYPE = "image/png";
export const VALIDATION_ERR_MSG = SharedConstants.FORM_NOT_VALID;
export const FEEDBACK_PROPERTIES = {
    name: "name",
    senderEmail: "senderEmail",
    subject: "subject",
    message: "message",
    screenshot: "screenshot"
};
export const validationMessage = {
    "name": {
        "required": `${NAME_TEXT} ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
    },
    "email": {
        "required": `${EMAIL_TEXT} ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        "email": `${EMAIL_TEXT} ${SharedConstants.INVALID_INPUT_CONTROL_VALIDATION}`
    },
    "subject": {
        "required": `${SUBJECT_TEXT} ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
    },
    "message": {
        "required": `${MESSAGE_TEXT} ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
    }
};
export const formError = {
    "name": "",
    "email": "",
    "subject": "",
    "message": ""
};
